<template>
  <div class="w-full h-full">
    <div v-if='!preview' class="w-full h-24 md:h-32 relative">
      <img class="object-contain w-full h-24 md:h-32" :src='video.thumbnailUrl' loading="lazy" />

      <div class="absolute top-0 left-0 right-0 bottom-0 flex content-center">
        <pbc-button class="mx-auto my-auto" @click='onPreview'>
          <play-circle />
        </pbc-button>
      </div>
    </div>

    <div v-else class="w-full h-24 md:h-32 relative">
      <video controls autoplay="true" :poster='video.thumbnail' muted="true" loop="true">
        <source :src="video.url" />
      </video>
    </div>
    <pbc-button class="w-full" @click="$emit('select', video)">
      <span class="w-full text-center">Select</span>
    </pbc-button>
  </div>
</template>
<script>
import PlayCircle from '@icons/PlayCircle.vue';
export default {
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  methods: {
    onPreview() {
      this.preview = true;
    }
  },
  data() {
    return {
      preview: false
    }
  },
  components: {
    PlayCircle
  }
}
</script>
